import React from "react";
import { Card, Table, Badge } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

// Animation container
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
    },
  },
};

// Row animation
const rowAnim = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: "easeOut" },
  },
};

function EmployeeTable({ employees }) {
  return (
    <Card className="p-4 shadow-sm border-0">
      {/* <h6 className="mb-3 fw-bold"></h6> */}

      <Table hover responsive className="align-middle">
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>Break</th>
            <th>Late</th>
            <th>Overtime</th>
            <th>Status</th>
          </tr>
        </thead>

        <motion.tbody variants={container} initial="hidden" animate="show">
          {employees.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center text-muted">
                No data available
              </td>
            </tr>
          ) : (
            employees.map((emp, i) => (
              <motion.tr
                key={`${emp.name}-${i}`}
                variants={rowAnim}
                whileHover={{
                  scale: 1.01,
                  backgroundColor: "#f8f9fa",
                }}
              >
                {/* NAME */}
                <td>
                  <div className="d-flex align-items-center">
                    <motion.img
                      src={`https://i.pravatar.cc/40?img=${i + 1}`}
                      alt="avatar"
                      className="rounded-circle me-2 shadow-sm"
                      style={{
                        width: "38px",
                        height: "38px",
                        border: "2px solid #f1f1f1",
                      }}
                      whileHover={{ scale: 1.2, rotate: 3 }}
                    />
                    <span className="fw-semibold">{emp.name}</span>
                  </div>
                </td>

                {/* DATE */}
                <td className="text-muted">{emp.date}</td>

                {/* CHECK IN */}
                <td>{emp.CheckIn}</td>

                {/* CHECK OUT */}
                <td>{emp.CheckOut}</td>

                {/* BREAK */}
                <td>{emp.Break}</td>

                {/* LATE */}
                <td className="text-muted fw-semibold">
                  {emp.Late}
                </td>


                {/* OVERTIME */}
                <td className="text-muted fw-semibold">
                  {emp.Overtime}
                </td>

                {/* STATUS */}
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <motion.div whileTap={{ scale: 0.9 }}>
                      {emp.status === "Present" ? (
                        <FaCheckCircle className="text-success" />
                      ) : (
                        <FaTimesCircle className="text-danger" />
                      )}
                    </motion.div>

                    <Badge
                      bg={emp.status === "Present" ? "success" : "danger"}
                      className="px-3 py-2"
                    >
                      {emp.status}
                    </Badge>
                  </div>
                </td>
              </motion.tr>
            ))
          )}
        </motion.tbody>
      </Table>
    </Card>
  );
}

export default EmployeeTable;